'use strict';

module.exports = function( key, value ) {
	var obj = {};
	obj[ key ] = value;
	return obj;
};



//////////////////
// WEBPACK FOOTER
// ./~/wpapi/lib/util/key-val-to-obj.js
// module id = 188
// module chunks = 0